module.exports = __webpack_public_path__ + "static/media/personSalesForce.6e72a2ac.png";